<header class="popup_header__2QTxC clearfix">
  <h3 class="popup_title__3q6Xh"><span>Claim This Listing</span></h3>
  <div class="popup_headerRight__c4FcP">
    <span [mat-dialog-close] class="popup_close__mJx2A color-primary--hover js-toggle-close">
      <i class="la la-close"></i>
    </span>
  </div>
</header>
<div mat-dialog-content class="bdy-mat-dialog-content">
  <div class="popup_body__1wtsy wil-scroll-bar ps">
    <div class="wil-scroll-container">
      <div>
        <div>
          <div>
            <form [formGroup]="listingClaimForm" (ngSubmit)="onSubmit()">

              <mat-form-field>
                <mat-label>First Name</mat-label>
                <input required matInput formControlName="firstname" placeholder="First Name" />
              </mat-form-field>

              <mat-form-field>
                <mat-label>Last Name</mat-label>
                <input required matInput formControlName="lastname" placeholder="Last Name" />
              </mat-form-field>

              <mat-form-field>
                <mat-label>Phone</mat-label>
                <input required matInput formControlName="phone" placeholder="Phone" />
              </mat-form-field>

              <mat-form-field>
                <mat-label>Email</mat-label>
                <input required matInput formControlName="email" placeholder="Email" type="email" />
              </mat-form-field>


              <p *ngIf="showError" class="errorMessage">{{ errorMessage }}</p>

              <button mat-raised-button class="wil-btn wil-btn--primary wil-btn--block wil-btn--md wil-btn--round"
                type="submit" [disabled]="!listingClaimForm.valid">
                Submit
              </button>


            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>